import { displayDollar } from "utilities/tableUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import K from "utilities/constants";
import { convertIntoDashUSFormat } from "utilities/dateUtility";

export const Columns = [
  {
    ...DefaultColumnOptions.Id,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
  },
  {
    headerName: "Client Name",
    field: "client.name",
    tooltipField: "client.name",
  },
  {
    headerName: "Invoice Number",
    field: "invoiceNumber",
    tooltipField: "invoiceNumber",
    headerTooltip: "Invoice Number",
  },
  {
    headerName: "Invoice Status",
    field: "status",
    valueGetter: ({ data }) =>
      K.InvoiceStatus[data.status] ?? K.NullPlaceholder,
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Invoice Date",
    field: "dueDate",
    sort: "desc",
    headerTooltip: "Invoice Date",
    valueGetter: ({ data }) => convertIntoDashUSFormat(data.dueDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Invoice Month",
    field: "invoiceMonth",
    tooltipField: "invoiceMonth",
  },
  {
    headerName: "Invoice Amount",
    field: "total",
    headerTooltip: "Invoice Amount",
    valueGetter: ({ data }) => displayDollar(data.total.toFixed(2)),
    tooltipValueGetter: ({ value }) => value,
  },
];
